import { isValidDecimalNumber, noZeroAfterDecimal } from 'utils/isValidDecimalNumber'
import { minMaxValidation } from 'utils/minBestMaxValidation'

const isFiniteNumber = (value) => typeof value === 'number' && Number.isFinite(value)

const hasSupportedPrecision = (value) => {
  const decimalPart = value.substr(value.indexOf('.'))
  return decimalPart.length <= '127'
}

export const isNumericInputAllowed = (value) => {
  return isFiniteNumber(Number(value)) && hasSupportedPrecision(value)
}

export const handleRangeFieldChange = async ({
  value,
  firstValue,
  secondValue,
  validationFields,
  validationBoundary,
  setValue,
  setError,
  saveSiteData,
  saveFieldName,
  requireNoZeroOnValidRange = true,
  saveWithTimeout
}) => {
  const errorMessage = minMaxValidation(firstValue, secondValue, validationFields, validationBoundary)

  if (errorMessage.field === '') {
    if (isValidDecimalNumber(Number(value))) {
      if (!requireNoZeroOnValidRange || noZeroAfterDecimal(value)) {
        setValue(value)
        setError(errorMessage)
      }

      const formattedValue = value === '' ? null : Number(Number.parseFloat(value).toFixed(10))
      const payload = { [saveFieldName]: formattedValue }

      if (saveWithTimeout) {
        await saveWithTimeout(() => saveSiteData(payload))
      } else {
        await saveSiteData(payload)
      }
    }
    return
  }

  if (isValidDecimalNumber(Number(value)) && noZeroAfterDecimal(value)) {
    setValue(value)
    setError(errorMessage)
  }
}

export const handleCalculatedCoverageChange = async ({
  value,
  setValue,
  saveSiteData,
  saveFieldName,
  saveWithTimeout
}) => {
  if (!isNumericInputAllowed(value)) {
    return
  }

  if (noZeroAfterDecimal(value)) {
    setValue(value)
  }

  await saveWithTimeout(() =>
    saveSiteData({ [saveFieldName]: Number(value).toFixed(10) })
  )
}
